import React from 'react';
import PropTypes from 'prop-types';
import * as SelfStoragePointType from '../../enums/SelfStoragePointType';
import Mixpanel, { MIXPANEL_EVENTS, MIXPANEL_LOCATIONS } from '../../helpers/Mixpanel';

const InfoBubbleHeader = props => {
    const { surveyCode, shouldEmitMixpanel } = props;

    const pointType = SelfStoragePointType.resolvePointTypeFromSurveyCode(surveyCode);
    if (!pointType) {
        return null;
    }

    const shouldTrackLocation =
        pointType === SelfStoragePointType.SELFSTORAGE_POINT_TYPE.HOUSING_STARTS ||
        pointType === SelfStoragePointType.SELFSTORAGE_POINT_TYPE.INFLUENCER;

    if (shouldEmitMixpanel && shouldTrackLocation) {
        Mixpanel.emitUserEvent(MIXPANEL_EVENTS.UPSELL_OPPORTUNITY, {
            timestamp: new Date().toISOString(),
            location:
                pointType === SelfStoragePointType.SELFSTORAGE_POINT_TYPE.HOUSING_STARTS
                    ? MIXPANEL_LOCATIONS.pointInfoHousings
                    : MIXPANEL_LOCATIONS.pointInfoConstructions,
        });
    }

    let title, isSS, pointTag;
    switch (pointType) {
        case SelfStoragePointType.SELFSTORAGE_POINT_TYPE.SS_FACILITY:
            title = 'SELF STORAGE';
            isSS = true;
            pointTag = 'OPERATING FACILITY';
            break;
        case SelfStoragePointType.SELFSTORAGE_POINT_TYPE.SS_CONSTRUCTION:
            title = 'SELF STORAGE';
            isSS = true;
            pointTag = 'DEVELOPMENT SITE';
            break;
        case SelfStoragePointType.SELFSTORAGE_POINT_TYPE.HOUSING_STARTS:
            title = 'HOUSING DEVELOPMENTS';
            isSS = true;
            pointTag = 'DEVELOPMENT SITE';
            break;
        case SelfStoragePointType.SELFSTORAGE_POINT_TYPE.INFLUENCER:
            title = 'COMMERCIAL DEVELOPMENTS';
            isSS = true;
            pointTag = 'DEVELOPMENT SITE';
            break;
        default:
            title = 'N/A';
            isSS = false;
            break;
    }

    let ssTag;
    if (isSS) {
        ssTag = <span className="tag">{pointTag}</span>;
    }
    return (
        <div className="header selectable-text">
            <span className="title">{title}</span>
            {ssTag}
        </div>
    );
};

InfoBubbleHeader.propTypes = {
    surveyCode: PropTypes.string,
    shouldEmitMixpanel: PropTypes.bool,
};

InfoBubbleHeader.defaultProps = {
    surveyCode: null,
    shouldEmitMixpanel: false,
};

export default InfoBubbleHeader;
